import React,{useState} from "react";
import { Link } from "react-router-dom";
import "./RegisterCustomer.css";
import { registerCustomer } from "../../redux/CustomerReducer";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
const RegisterCustomer = () => {

  const dispatch=useDispatch();
  const navigate=useNavigate();

    const[user,setUser]=useState(
        {
            email:"",
            name:"",
            phone:"",
            password:"",
            userType:"Customer"
        }
    )

    const handleChange=(e)=>{

        const{name,value}=e.target

        setUser(
            {
                ...user,[name]:value
            }
        )
    }

    console.log("user",user)

    const signupClicked=async()=>{
      const response=await dispatch(registerCustomer(user))


      console.log("response",response?.payload?.data?.message)

      Swal.fire(
        'Good',
        response?.payload?.data?.message,
        'success'
      )


        if(response?.payload?.data?.success)
        {

          navigate("/customer/login")
        }


    }

  return (
    <div className="mainContainerLogin mainContainerSignup">
      <div className="userLoginTxt">Customer Signup</div>

      <div className="topRowFieldsSignup">
        <div className="topInputFieldLogin topInputFieldSignup">
          <div className="inputTxtLogin">Email</div>
          <input
            className="inputLogins inputSignup"
            type="email"
            placeholder="Enter Email"

            onChange={handleChange}
            name="email"
          />
        </div>
        <div className="topInputFieldLogin topInputFieldSignup">
          <div className="inputTxtLogin">Name</div>
          <input
            className="inputLogins inputSignup"
            type="text"
            placeholder="Enter Name"

            onChange={handleChange}
            name="name"
          />
        </div>
      </div>
      <div className="topRowFieldsSignup">
        <div className="topInputFieldLogin topInputFieldSignup">
          <div className="inputTxtLogin">Mobile Number</div>
          <input
            className="inputLogins inputSignup"
            type="number"
            placeholder="Enter Mobile Number"
            
            onChange={handleChange}
            name="phone"
          />
        </div>
        <div className="topInputFieldLogin topInputFieldSignup">
          <div className="inputTxtLogin"
          type="password"
          
          >Password</div>
          <input
            className="inputLogins inputSignup"
            type="password"
            placeholder="Enter Password"
            onChange={handleChange}
            name="password"
          />
        </div>
      </div>


      <button className="loginBtn"
      onClick={signupClicked}
      >Sign up</button>

      <div className="ntMemberTxt">
        Already a member?
      <Link to="/customer/login">   <span className="spCreatAccnt">Login</span></Link>
      </div>
    </div>
  );
};

export default RegisterCustomer;
